import { useEffect } from "react";
import { useSelector } from "react-redux";
import { datadogRum } from "@datadog/browser-rum";

const DatadogUserWrapper = () => {
  const userEmail = useSelector((state: any) => state?.data?.forgeRockAuthInfo?.userEmail);

  useEffect(() => {
    try {
      if (userEmail) {
        datadogRum.setUser({
          id: userEmail,
          email: userEmail,
        });
      } else {
        datadogRum.clearUser();
      }
    } catch (error) {
      console.warn("Error handling user persistence:", error);
    }
  }, [userEmail]);

  return null;
};

export default DatadogUserWrapper;
